module.exports = __webpack_public_path__ + "static/media/SSIS.c1a6156c.png";